module.exports = "<app-sidenav *ngIf=\"currentUser && currentAccountRole && currentAccountRole === 'BasicUser' || currentAccountRole === 'PremiumUser'\"></app-sidenav>\n<app-admin-sidenav *ngIf=\"currentUser && currentAccountRole && currentAccountRole === 'Admin'\"></app-admin-sidenav>\n<app-artist-sidenav *ngIf=\"currentUser && currentAccountRole && currentAccountRole === 'Artist'\"></app-artist-sidenav>\n<app-content></app-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.html
// module id = ./src/app/components/dashboard/dashboard.component.html
// module chunks = main